export const clientInfoFormDecorator = {

	general_company_information: {
		$__company_name_label: "Company name",
		$__trading_company_name_label: "Trading company name (if applicable)",
		$__reg_company_number_label: "Registration number",
		$__reg_date_label: "Registration date",
		$__reg_date_type: "date",

		company_registration_address: {
			$__street_label: "Street",
			$__city_label: "City",
			$__country_label: "Country",
			$__country_type: "country",
			$__postal_code_label: "Postal code",
		},

		$__company_registration_address_decorator: {
			blockless: true,
			title: "Company registration address",
			gridTemplateColumns: "1fr 1fr",
		},

		company_business_place: {
			$__street_label: "Street",
			$__city_label: "City",
			$__country_label: "Country",
			$__country_type: "country",
			$__postal_code_label: "Postal code",
		},

		$__company_business_place_decorator: {
			blockless: true,
			title: "Company's place of business (if different from registratered)",
			gridTemplateColumns: "1fr 1fr",
		},

		$__business_description_label:
			"Business description (Required to help us understand your company's activities and comply with Canadian AML/CFT regulations. Please describe what your business does and how it generates revenue.)",

		$__required_license_label: "Does your business require a license to provide declared business activities?",
		$__required_license_type: "radio",
		$__license_number_label: "Number",
		$__license_issuer_label: "Issuer",
		$__license_issuer_country_label: "Issuer Country",
		$__license_issuer_country_type: "country",
	},
	$__general_company_information_decorator: {
		title: "1. General Company Information",
		sx: { gap: "20px" },
		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["company_name", "trading_company_name"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["reg_company_number", "reg_date"],
			},
			{
				blockless: true,
				order: ["company_registration_address"],
			},
			{
				blockless: true,
				order: ["company_business_place"],
			},
			{
				blockless: true,
				order: ["business_description"],
			},
			{
				blockless: true,
				order: ["required_license"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				order: ["license_number", "license_issuer", "license_issuer_country"],
			},
		],
	},

	authorised_representative: {
		$__full_name_label: "Full name",
		$__date_of_birth_label: "Date of birth",
		$__date_of_birth_type: "date",
		$__citizenship_label: "Citizenship",
		$__citizenship_type: "country",
		$__residential_address_label: "Residential address (full physical address, not P.O. box)",
		$__id_type_label: "ID Type",
		$__id_type_type: "select",
		$__id_number_label: "ID Number",
		$__politicaly_exposed_person_label: "Politically Exposed Person (PEP) status",
		$__us_person_label: "U.S. person (for FATCA / sanctions check)",
		$__authorization_basis_label: "Basis for authorisation",
		$__authorization_basis_type: "select",
		authorization_basis_other: "",
		$__authorization_basis_other_label: "Specify authorisation basis",
		$__phone_number_label: "Phone number for communication",
		$__email_address_label: "Email address for communication",
	},
	$__authorised_representative_decorator: {
		title: "2. Authorised Representative",
		subtitle:
			"The authorised representative (signatory) is regarded as the person who has the legal authority to act on behalf of the company, including signing onboarding documents, providing operational instructions, confirming payout details, and authorising additional users or other changes related to the account.",
		sx: { gap: "20px" },

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["full_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["citizenship", "residential_address"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["id_type", "id_number"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["politicaly_exposed_person", "us_person"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				sx: { alignItems: "end" },
				order: ["authorization_basis", "authorization_basis_other"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				sx: { alignItems: "end" },
				order: ["phone_number", "email_address"],
			},
		],
	},

	director: [
		{
			$__full_name_label: "Full name",
			$__date_of_birth_label: "Date of birth",
			$__date_of_birth_type: "date",
			$__citizenship_label: "Citizenship / Nationality",
			$__citizenship_type: "country",
			$__residence_label: "Country of Residence",
			$__residence_type: "country",
			$__politicaly_exposed_person_label: "Are you a Politically Exposed Person (PEP)?",
			$__politicaly_exposed_person_type: "radio",
			$__us_person_label: "Are you a U.S. person?",
			$__us_person_type: "radio",
		},
	],
	$__director_asblocks: true,
	$__director_itemtitle: "Director",
	$__director_addbuttontitle: "Add Director",
	$__director_decorator: {
		title: "3. Director(s)",

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["full_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["citizenship", "residence"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["politicaly_exposed_person", "us_person"],
			},
		],
		sx: { gap: "20px" },
	},

	beneficial_owner: [
		{
			$__full_name_label: "Full name",
			$__date_of_birth_label: "Date of birth",
			$__date_of_birth_type: "date",
			$__citizenship_label: "Citizenship / Nationality",
			$__citizenship_type: "country",
			$__residential_address_label: "Residential address",
			$__ownership_percentage_label: "Ownership percentage (%)",
			$__ownership_percentage_type: "number",
			$__politicaly_exposed_person_label: "Are you a Politically Exposed Person (PEP)?",
			$__politicaly_exposed_person_type: "radio",
			$__us_person_label: "Are you a U.S. person?",
			$__us_person_type: "radio",
			$__id_type_label: "ID Type",
			$__id_type_type: "select",
			$__id_number_label: "ID Number",
			$__id_country_label: "Issuing country",
			$__id_country_type: "country",
			$__id_expiry_date_label: "Expiry date",
			$__id_expiry_date_type: "date",
		},
	],
	$__beneficial_owner_asblocks: true,
	$__beneficial_owner_itemtitle: "Beneficiary",
	$__beneficial_owner_addbuttontitle: "Add Beneficiary",
	$__beneficial_owner_decorator: {
		title: "Beneficial owner(s)",
		sx: { gap: "20px" },
		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["full_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["citizenship", "residential_address"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["ownership_percentage"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["politicaly_exposed_person", "us_person"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				sx: { alignItems: "end" },
				order: ["id_number", "id_country", "id_expiry_date"],
			},
		],
	},

	payout_account_details: {
		$__account_holder_name_label:
			"Account holder name: (must match company or authorised payment agent name) (If payment agent) please provide payment agent agreement",
		$__bank_name_label: "Bank name",
		$__bank_country_label: "Bank country",
		$__bank_country_type: "country",
		$__iban_account_number_label: "IBAN / Account number",
		$__bic_swift_label: "BIC / SWIFT",
		$__currency_label: "Currency",
		$__currency_type: "select",
		$__bank_statement_upload_label: "Bank statement or account confirmation",
		$__bank_statement_upload_subtitle: "showing account holder and IBAN",
		$__bank_statement_upload_type: "file",
	},
	$__payout_account_details_decorator: {
		title: "5. Payout Account Details",
		subtitle:
			"Please provide the bank account details to which payouts will be sent. The account must belong to the client company or its authorised payment agent.",
		sx: { gap: "20px" },

		blocks: [
			{
				blockless: true,
				order: ["account_holder_name"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["bank_name", "bank_country"],
			},
			{
				blockless: true,
				gridTemplateColumns: " 2fr 1fr 1fr",
				order: ["iban_account_number", "bic_swift", "currency"],
			},
			{
				blockless: true,
				order: ["bank_statement_upload"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr 1fr",
				sx: { alignItems: "end" },
				order: ["id_number", "id_country", "id_expiry_date"],
			},
		],
	},

	document_uploads: {
		company: {
			$__certificate_of_incorporation_label: "Certificate of Incorporation",
			$__certificate_of_incorporation_subtitle: "Confirms company registration",
			$__certificate_of_incorporation_type: "file",

			$__memorandum_and_articles_of_association_label: "Memorandum and Articles of Association",
			$__memorandum_and_articles_of_association_subtitle: "Confirms company structure and governance",
			$__memorandum_and_articles_of_association_type: "file",

			$__extract_from_company_register_label: "Extract from Company Register (recent, ≤3 months) or equivalent",
			$__extract_from_company_register_subtitle: "Confirms directors, shareholders, and registered address",
			$__extract_from_company_register_type: "file",

			$__proof_of_registered_address_label: "Proof of registered address (only if not visible in register extract)",
			$__proof_of_registered_address_subtitle: "e.g. Certificate of Incumbency or Certificate of Registered Office",
			$__proof_of_registered_address_type: "file",

			$__bank_statement_or_account_confirmation_label: "Bank statement or account confirmation",
			$__bank_statement_or_account_confirmation_subtitle: "Shows account holder name and IBAN for payout account",
			$__bank_statement_or_account_confirmation_type: "file",
		},
		$__company_decorator: {
			title: "A. Company Documents",
			blockless: true,
		},

		additional_documents: {
			$__payment_agent_agreement_label: "Payment Agent Agreement (if applicable)",
			$__payment_agent_agreement_subtitle: "Required only if payouts go to a payment agent’s account",
			$__payment_agent_agreement_type: "file",

			$__proof_of_business_address_label: "Proof of actual business address (if different from registered)",
			$__proof_of_business_address_subtitle: "(if applicable) Required only if the company operates from another location",
			$__proof_of_business_address_type: "file",

			$__operating_licence_label: "Relevant operating licence",
			$__operating_licence_subtitle:
				"e.g. gambling, investment, or financial licence (if gambling license) should consist of a list of approved websites by the regulator.",
			$__operating_licence_type: "file",

			$__aml_ctf_policy_label: "AML/CTF Policy",
			$__aml_ctf_policy_subtitle:
				"Should contain: KYC/KYB, CDD/EDD measures, sanctions screening, list of high/prohibited countries, ongoing monitoring measures.",
			$__aml_ctf_policy_type: "file",

			$__mrlo_cv_label: "MLRO CV",
			$__mrlo_cv_subtitle: "Confirms AML officer’s experience and appointment",
			$__mrlo_cv_type: "file",

			$__power_of_attorney_label: "Power of Attorney",
			$__power_of_attorney_subtitle:
				"Confirms authorisation of the signatory / representative*\n\n*Not required if the authorised representative is Director of the company.",
			$__power_of_attorney_type: "file",

			$__declaration_of_trust_label: "Declaration of Trust",
			$__declaration_of_trust_subtitle: "(if nominee identified) If beneficial ownership is held in trust",
			$__declaration_of_trust_type: "file",

			$__processing_statement_label: "Processing statement (last 6 months)",
			$__processing_statement_subtitle: "Required if the client has selected the Card Processing service",
			$__processing_statement_type: "file",

			$__pci_dss_certificate_label: "PCI DSS Certificate",
			$__pci_dss_certificate_subtitle: "(applicable for card processing services only) Required if the client stores or processes card data",
			$__pci_dss_certificate_type: "file",
		},
		$__additional_documents_decorator: {
			title: "B. Additional documents",
			blockless: true,
		},

		corporate_shareholders: {
			$__certificate_of_incorporation_label: "Certificate of Incorporation (of the legal entity)",
			$__certificate_of_incorporation_subtitle: "Confirms company registration",
			$__certificate_of_incorporation_type: "file",

			$__extract_from_company_register_label: "Extract from Company Register (recent, ≤3 months)",
			$__extract_from_company_register_subtitle: "Confirms ownership, management, and registered address",
			$__extract_from_company_register_type: "file",

			$__ownership_structure_label: "Proof of ownership chain to ultimate beneficial owners",
			$__ownership_structure_subtitle: "Shows full control structure",
			$__ownership_structure_type: "file",

			$__directors_and_beneficial_owners_ids_label:
				"ID document and proof of address for directors/beneficial owners of the corporate shareholder/director",
			$__directors_and_beneficial_owners_ids_subtitle: "Required for transparency and traceability",
			$__directors_and_beneficial_owners_ids_type: "file",
		},
		$__corporate_shareholders_decorator: {
			title: "С. Corporate Shareholders / Directors (if applicable)",
			subtitle: "If any shareholder or director is a legal entity, please upload the following documents.",
			blockless: true,
		},
	},
	$__document_uploads_decorator: {
		title: "7. Document Uploads",
		sx: { gap: "30px" },
		subtitle:
			"Please upload the required documents below. All files must be clear, valid, and preferably in PDF format. If a document is not yet available, please inform your Sales Manager.",
	},
};

export const clientInfoMock = {
	form_intro: {},

	general_company_information: {
		company_name: "",
		trading_company_name: "",
		reg_company_number: "",
		reg_date: 0,

		company_registration_address: {
			street: "",
			city: "",
			country: "",
			postal_code: "",
		},

		company_business_place: {
			street: "",
			city: "",
			country: "",
			postal_code: "",
		},

		business_description: "",

		required_license: "",
		$__required_license_values: ["Yes", "No"],

		license_number: "",
		$__license_number_linked: "required_license",
		$__license_number_linked_value: "Yes",

		license_issuer: "",
		$__license_issuer_linked: "required_license",
		$__license_issuer_linked_value: "Yes",

		license_issuer_country: "",
		$__license_issuer_country_linked: "required_license",
		$__license_issuer_country_linked_value: "Yes",
	},

	authorised_representative: {
		full_name: "",
		date_of_birth: "",
		citizenship: "",
		residential_address: "",

		id_type: "Select...",
		$__id_type_values: ["Passport", "Driver's License", "National ID"],

		id_number: "",

		politicaly_exposed_person: false,

		us_person: false,

		authorization_basis: "Select...",
		$__authorization_basis_values: ["Power of Attorney", "Statutes", "Board Resolution", "Other"],

		authorization_basis_other: "",
		$__authorization_basis_other_linked: "authorization_basis",
		$__authorization_basis_other_linked_value: "Other",

		phone_number: "",
		email_address: "",
	},

	director: [
		{
			full_name: "",
			date_of_birth: "",
			citizenship: "",
			residence: "",

			politicaly_exposed_person: "",
			$__politicaly_exposed_person_values: ["Yes", "No"],

			us_person: "",
			$__us_person_values: ["Yes", "No"],
		},
	],

	beneficial_owner: [
		{
			full_name: "",
			date_of_birth: "",
			citizenship: "",
			residential_address: "",
			ownership_percentage: "",

			politicaly_exposed_person: "",
			$__politicaly_exposed_person_values: ["Yes", "No"],

			us_person: "",
			$__us_person_values: ["Yes", "No"],

			id_type: "Select ID Type...",
			$__id_type_values: ["Passport", "National ID", "Driver's License"],

			id_number: "",
			id_country: "",
			id_expiry_date: "",
		},
	],

	payout_account_details: {
		account_holder_name: "",
		bank_name: "",
		bank_country: "",
		iban_account_number: "",
		bic_swift: "",

		currency: "EUR",
		$__currency_disabled: true,

		bank_statement_upload: "",
	},

	document_uploads: {
		company: {
			certificate_of_incorporation: "",
			memorandum_and_articles_of_association: "",
			extract_from_company_register: "",
			proof_of_registered_address: "",
			bank_statement_or_account_confirmation: "",
		},

		additional_documents: {
			payment_agent_agreement: "",
			proof_of_business_address: "",
			operating_licence: "",
			aml_ctf_policy: "",
			mrlo_cv: "",
			power_of_attorney: "",
			declaration_of_trust: "",
			processing_statement: "",
			pci_dss_certificate: "",
		},

		beneficial_owners: {
			government_id: "",
			proof_of_address: "",
		},

		directors: {
			government_id: "",
			proof_of_address: "",
		},

		corporate_shareholders: {
			certificate_of_incorporation: "",
			extract_from_company_register: "",
			ownership_structure: "",
			directors_and_beneficial_owners_ids: "",
		},
	},

	consents_and_warranties: {
		consent_to_data_processing_block: {
			consent_to_data_processing: false,
		},

		acceptance_of_the_privacy_policy_block: {
			acceptance_of_the_privacy_policy: false,
		},

		acceptance_of_the_general_service_terms_and_conditions_block: {
			acceptance_of_the_general_service_terms_and_conditions: false,
		},

		warrant_and_undertaking_block: {
			acceptance_of_the_general_service_terms_and_conditions: false,
		},
	},
};

export const clientWebsitesMock = {
	information_about_e_shop: {

		website_url_address: "",
		company_name: "",
		registration_number: '',
		owner_of_the_domain_name: "",
		creation_date: "",

		legal_address: {
			street: '',
			city: '',
			country: '',
			zip: '',
		},

		test_username: "",
		test_password: "",
		support_e_mail: "",
		support_phone: "",
		descriptor_city_filed: "",
		MCC_code: "",
		country_subdivision_name_or_code: "",
		acquirers_contact_person: "",
		email: "",
		phone: "",
	},

	information_about_goods: {
		goods_description: "",

		licence_required: "",
		$__licence_required_values: ["Yes", "No"],

		have_licence: "",
		$__have_licence_values: ["Yes", "No"],

		offer_free_trial: "",
		$__offer_free_trial_values: ["Yes", "No"],

		age_restrictions: "",
		$__age_restrictions_values: ["Yes", "No"],

		age_restrictions_description: "",
		$__age_restrictions_description_linked: "age_restrictions",
		$__age_restrictions_description_linked_value: "Yes",

		country_restrictions: [
			{
				alpha2: "",
				name: "",
				$__alpha2_type: "flag",
				$__name_type: "plain",
			},
		],

		clients_residents: {
			eu_countries: 0,
			asia: 0,
			cis_countries: 0,
			usa_and_canada: 0,
			others: 0,
		},

		target_audience: " ",
	},

	questionnaire_for_sellers_of_goods: {
		company_names_and_countries_of_basic_goods_suppliers: "",

		courier_delivery_companies: "",

		own_goods_stock: "",
		$__own_goods_stock_values: ["Yes", "No"],

		own_goods_stock_address: "",
		$__own_goods_stock_address_linked: "own_goods_stock",
		$__own_goods_stock_address_linked_value: "Yes",
	},

	questionnaire_for_other_merchants: {
		software_developer: "",

		software_certification: "",
		$__software_certification_values: ["Yes", "No"],

		identification_of_customers_at_delivery_time: "",

		identification_of_customers_at_delivery_time_description: "",
		$__identification_of_customers_at_delivery_time_description_linked: "identification_of_customers_at_delivery_time",
		$__identification_of_customers_at_delivery_time_description_linked_value: "Yes",

		affiliate_program: "",
		$__affiliate_program_values: ["Yes", "No"],

		affiliate_networks: "",
		$__affiliate_networks_values: ["Yes", "No"],

		affiliate_networks_url: "",
		$__affiliate_networks_url_linked: "affiliate_networks",
		$__affiliate_networks_url_linked_value: "Yes",

		affiliate_access_to_card_data: "",
		$__affiliate_access_to_card_data_values: ["Yes", "No"],
	},

	merchant_website_policies: {
		terms_and_conditions_url: "",
		privacy_policy_url: "",
		contacts_info_url: "",
		customer_support_url: "",
		refund_policy_url: "",
		cancelation_policy_url: "",
		shipping_policy_url: "",
		aml_policy_url: "",
		age_limits_policy_url: "",
		affiliate_policy_url: "",
	},

	operation_control: {
		process_cardholder_data: "",
		$__process_cardholder_data_values: ["Yes", "No"],

		customers_registration_procedure: "",

		protection_methods: "",

		fraud_methods: {
			cisp: "",
			$__cisp_values: ["Yes", "No"],

			pci_dss: "",
			$__pci_dss_values: ["Yes", "No"],
		},
	},

	payment_possibilities: {
		payment_type: {
			single_sale: false,
			recurring: false,
			three_ds: false,
			non_3ds: false,
		},

		recurring_billing: {
			weekly: false,
			monthly: false,
			annual: false,
		},

		transaction_limits: "",
	},

	processing_information: {
		min_transaction_amount: 0,

		max_transaction_amount: 0,

		processing_currencies: [
			{
				code: "",
				$__code_type: "plain",
				name: "",
				$__name_type: "plain",
			},
		],
		$__processing_currencies_possible_values: [
			{
				id: 1,
				code: "EUR",
				name: "Euro",
			},
			{
				id: 2,
				code: "USD",
				name: "US Dollar",
			},
		],

		settlement_currencies: [
			{
				code: "",
				$__code_type: "plain",
				name: "",
				$__name_type: "plain",
			},
		],
		$__settlement_currencies_possible_values: [
			{
				id: 1,
				code: "EUR",
				name: "Euro",
			},
			{
				id: 2,
				code: "USD",
				name: "US Dollar",
			},
		],

		start_up: "",
		$__start_up_values: ["Yes", "No"],

		split_by_card_brands: {
			visa: 0,
			mastercard: 0,
			others: 0,
		},

		expected_turnover_cards: {
			max_count: 0,
			average_count: 0,
			max_volume: 0,
			average_volume: 0,
			max_chargebacks: 0,
			average_chargebacks: 0,
			max_refunds: 0,
			average_refunds: 0,
		},


		expected_turnover_other_payment_systems: {
			max_count: 0,
			average_count: 0,
			max_volume: 0,
			average_volume: 0,
			max_refunds: 0,
			average_refunds: 0,
		},
	},

	payment_systems: {
		credit_cards: {
			visa: false,
			mastercard: false,
		},

		kind_of_terminals: {
			ecomm: false,
			recurring: false,
			three_ds: false,
			non_three_ds: false,
		},

		other_payment_systems: {
			skrill: false,
			sofort: false,
			ems: false,
			poli_payments_australia: false,
			china_union_pay: false,
			wirecard: false,
			pay_safe_card: false,
		},
	},

	comments: {
		comments: "",
	},

	documents: {
		licenses: "",
		$__licenses_type: "file",

		pci_dss_certificate: "",
		$__pci_dss_certificate_type: "file",

		processing_history: "",
		$__processing_history_type: "file",
	},

	information_acknowledgement: {
		trushful_information: "",
		check_information: "",
		scan_websites: "",
	},
};